import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { TableColumn } from "./TableColumn";

type Props = {
  status: string;
  data: any;
  handleApprovedAmount: any;
  handleProcessProduct: any;
};

function SelectedProductsTable({
  status,
  data,
  handleApprovedAmount,
  handleProcessProduct,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="my-10">
      <Table
        header={{
          title: t(
            "INVENTORY_REQUISITION.REQUISITION_DETAILS.SELECT_PRODUCTS_SECTION_HEADER",
          ),
        }}
        columns={
          TableColumn(
            t,
            handleApprovedAmount,
            status,
            handleProcessProduct,
          ) as any
        }
        rows={data || []}
      />
    </div>
  );
}

export default SelectedProductsTable;
